var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "currentColor",
    d: "M18.3333 1.83366C18.7754 1.83366 19.1993 2.00925 19.5118 2.32181C19.8244 2.63437 20 3.0583 20 3.50033V11.8337C20 12.2757 19.8244 12.6996 19.5118 13.0122C19.1993 13.3247 18.7754 13.5003 18.3333 13.5003H5C4.55797 13.5003 4.13405 13.3247 3.82149 13.0122C3.50893 12.6996 3.33333 12.2757 3.33333 11.8337V1.83366C3.33333 1.39163 3.50893 0.967708 3.82149 0.655147C4.13405 0.342587 4.55797 0.166992 5 0.166992H10L11.6667 1.83366H18.3333ZM1.66667 3.50033V15.167H16.6667V16.8337H1.66667C1.22464 16.8337 0.800716 16.6581 0.488155 16.3455C0.175595 16.0329 0 15.609 0 15.167V7.66699V3.50033H1.66667ZM5 3.50033V11.8337H18.3333V3.50033H5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0ba98ada.svg";
export { ForwardRef as ReactComponent };